<div class="container" *ngIf="templatesExist$ | async">
	<div class="button-container">
		<ion-fab>
			<ion-fab-button (click)="create()">
				<ion-icon name="create-outline"></ion-icon>
			</ion-fab-button>
		</ion-fab>
	</div>
</div>
